export const COMPARE_PLANS = 'COMPARE_PLANS';

const uri = '/webapi/xm/1/settings?embed=account';

export const GET_CURRENT_PLAN_DETAILS = 'GET_CURRENT_PLAN_DETAILS';
export const GET_CURRENT_PLAN_DETAILS_START = `${GET_CURRENT_PLAN_DETAILS}_START`;
export const GET_CURRENT_PLAN_DETAILS_SUCCESS = `${GET_CURRENT_PLAN_DETAILS}_SUCCESS`;
export const GET_CURRENT_PLAN_DETAILS_FAIL = `${GET_CURRENT_PLAN_DETAILS}_FAIL`;
export const getCurrentPlanDetails = () => ({
  type: GET_CURRENT_PLAN_DETAILS,
  meta: {
    xmApi: true,
    method: 'get',
    uri,
  },
});
